"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_helmet_1 = require("react-helmet");
var root_1 = require("react-hot-loader/root");
var react_toastify_1 = require("react-toastify");
var connected_react_router_1 = require("connected-react-router");
require("./App.scss");
var Router_1 = require("./Router");
var actions_1 = require("./features/auth/state/actions");
var constants_1 = require("@app/shared/constants");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.componentDidMount = function () {
        var _this = this;
        this.props.onLoginWithJwt();
        axios_1.default.interceptors.response.use(function (response) {
            // Do something with response data
            return response;
        }, function (error) {
            // Do something with response error
            var errorMsg = error.response.data.errorMessage;
            // TODO: get better error messages from server endpoints
            if (error.response.status === 401) {
                if (!react_toastify_1.toast.isActive(constants_1.INTERCEPTED_BAD_REQUEST)) {
                    var badRequestMsg = errorMsg || 'Bad Request';
                    react_toastify_1.toast.error("" + badRequestMsg, {
                        autoClose: 10000,
                        toastId: constants_1.INTERCEPTED_BAD_REQUEST
                    });
                }
            }
            else if (error.response.status === 403) {
                // Unauthorized Error
                return _this.props.onSessionExpire();
            }
            else if (error.response.status === 404) {
                // Resource not found
                return _this.props.store.dispatch(connected_react_router_1.replace('/dash/not-found', { prevPath: location.pathname }));
            }
            else if (error.response.status === 500) {
                if (!react_toastify_1.toast.isActive(constants_1.INTERCEPTED_INTERNAL_SERVER_ERROR) && errorMsg !== 'Expired Password') {
                    var internalServerErrorMsg = errorMsg || 'Internal Server Error';
                    react_toastify_1.toast.error("" + internalServerErrorMsg, {
                        autoClose: 10000,
                        toastId: constants_1.INTERCEPTED_INTERNAL_SERVER_ERROR
                    });
                }
                error.message = errorMsg || error.message;
            }
            // else {
            //   if (!toast.isActive(INTERCEPTED_UNKNOWN_ERROR)) {
            //     const unknownErrorMsg: string = errorMsg || 'Unknown Error';
            //     toast.error(`${unknownErrorMsg}`, {
            //       autoClose: 10000,
            //       toastId: INTERCEPTED_UNKNOWN_ERROR
            //     });
            //   }
            // }
            return Promise.reject(error);
        });
    };
    App.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_helmet_1.Helmet, { titleTemplate: "%s - Blast", meta: [{
                        charSet: 'utf-8'
                    }, {
                        httpEquiv: 'X-UA-Compatible',
                        content: 'IE=edge'
                    }, {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1'
                    }, {
                        name: 'robots',
                        content: 'noindex'
                    }] },
                react_1.default.createElement("link", { rel: "shortcut icon", sizes: "196x196", href: "/icon-196.png" }),
                react_1.default.createElement("link", { rel: "apple-touch-icon", href: "/icon-120.png", sizes: "120x120" }),
                react_1.default.createElement("link", { rel: "apple-touch-icon", href: "/icon-152.png", sizes: "152x152" }),
                react_1.default.createElement("link", { rel: "apple-touch-icon", href: "/icon-180.png", sizes: "180x180" }),
                react_1.default.createElement("meta", { name: "msapplication-TileColor", content: "#FFFFFF" }),
                react_1.default.createElement("meta", { name: "msapplication-TileImage", content: "/icon-144.png" }),
                react_1.default.createElement("meta", { name: "msapplication-config", content: "/browserconfig.xml" }),
                react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
                react_1.default.createElement("link", { rel: "icon", type: "image/png", href: "/icon-196.png", sizes: "196x196" })),
            react_1.default.createElement(react_redux_1.Provider, { store: this.props.store },
                react_1.default.createElement(Router_1.AppRouter, null)),
            react_1.default.createElement(react_toastify_1.ToastContainer, { pauseOnFocusLoss: false, hideProgressBar: true, draggable: false, position: "top-center", transition: react_toastify_1.Slide })));
    };
    return App;
}(react_1.Component));
exports.App = App;
var mapDispatchToProps = {
    onLoginWithJwt: actions_1.loginWithJwt,
    onSessionExpire: actions_1.expireBlastSession
};
var ConnectedApp = react_redux_1.connect(null, mapDispatchToProps)(App);
exports.default = root_1.hot(ConnectedApp);
